import React, { useRef } from "react";
import OndeffModal from "./OndeffModal";

const QuoteRequestModalBlog = (props) => {
    const childRef = useRef();

    const handleClick = () => {
        if (childRef.current) {
          childRef.current.triggerChangeShowModal();
        }
    };

    return (
        <>
            {props.showButton && <a href="#" className="service-blog" data-keygroup={props.code} onClick={handleClick}>{props.label}</a>}
            <OndeffModal
                initialFormData={props.initialFormData}
                ondeffCode={props.ondeffCode}
                proid={props.proid}
                startVisible={props.startVisible}
                ref={childRef}
            />
        </>
    )
}

export default QuoteRequestModalBlog;